import { isArray, isObject } from "lodash";
import React from "react";
import {
  DeleteButton,
  DeleteWithConfirmButton,
  SaveButton,
  Toolbar,
  useRefresh,
} from "react-admin";

const CustomEditToolbar = (props: any) => {
  const { isDeleteWithConfirm, isSaveWithOnSuccessThenRefresh, isShowDelete } =
    props;

  const redirectLink: { saveLink: string; deleteLink: string } =
    props.redirectLink;

  const refresh = useRefresh();

  const deleteBtn = () => {
    if (isShowDelete === false) {
      return null;
    }
    if (isDeleteWithConfirm) {
      return (
        <DeleteWithConfirmButton
          redirect={
            isObject(redirectLink) ? redirectLink.deleteLink : redirectLink
          }
        />
      );
    }
    return (
      <DeleteButton
        redirect={
          isObject(redirectLink) ? redirectLink.deleteLink : redirectLink
        }
      />
    );
  };

  return (
    <Toolbar {...props}>
      {isSaveWithOnSuccessThenRefresh ? (
        <SaveButton
          onSuccess={() => {
            refresh();
          }}
          disabled={props.invalid}
        />
      ) : (
        <SaveButton
          redirect={
            isObject(redirectLink) ? redirectLink.saveLink : redirectLink
          }
          disabled={props.invalid}
        />
      )}

      {deleteBtn()}
    </Toolbar>
  );
};

export default CustomEditToolbar;
